import { createContext } from 'react';
import { GetAccountsHistoryParams } from '@goldwasserexchange/actor/rest-services';

export const accountsHistoryParamsContext = createContext<Partial<GetAccountsHistoryParams>>({});
